import axios from "axios";

export const getSubscription = (idToken, locale) => {
  const localeSplit = locale.split("-");
  return axios({
    method: "GET",
    baseURL: GFN_BASE,
    url: DMO_SUBSCRIPTION_ENDPOINT,
    params: {
      locale: `${localeSplit[0].toLowerCase()}_${localeSplit[1].toUpperCase()}`,
    },
    data: {},
    headers: {
      "Content-Type": "application/json",
      idToken,
    },
  }).then((response) => response.data);
};
